// extracted by mini-css-extract-plugin
export default {"container":"USBlockContainer_container__ez2uy"};